import React, { useState, useEffect } from "react";
import { Tabs, Tab, ModalBody, Modal, Button, Image, Table, Row, Col } from "react-bootstrap";
import Modalpopup from '../Modals/Modal';
import { useDispatch, useSelector } from "react-redux";
import Loader from '../Loader/Loader';
import Toaster from '../Toaster/Toaster'
import { getSharedNotes } from "../../../store/Actions/Notes";
import callAPI from "../../../commonservices/APIRequests";
import CreateNote from "./NewCreateNotes/CreateNote";
import ConfirmationPopup from "../../Shared/common/components/Modalpopups/ConfirmationPopup/ConfirmationPopup";
import { X } from 'lucide-react';
import SharedNotesTable from "./SharedNotesTable";
import auditsVirtualIcon from '../../../assets/images/Action-Icons/Virtual.svg';
import auditsVirtualActiveIcon from '../../../assets/images/Action-Icons/Virual-Audits-Active-Icon.svg'
import auditsInpersonIcon from '../../../assets/images/Action-Icons/InPerson.svg';
import auditsInpersonActiveIcon from '../../../assets/images/Action-Icons/Audits-InPerson-Active.svg';
import PopupIcon from '../../../assets/images/Popup-Icons/PopupIcons_Notes.svg'
import viewDealerNotesIcon from '../../../assets/images/Popup-Icons/PopupIcons_View_Dealer_Notes_White.svg'
import './ViewNotes.css'
import { setCreateNotesData, setSharedNotes } from "../../../store/Reducers/Notes";
import { setApiRefresh, setLenderBanner } from "../../../store/Reducers/Shared";
import BorderEditIcon from '../../../assets/images/Action-Icons/Border-Edit-Icon.svg'
import { Eye } from "lucide-react";
import { viewDocument } from "../../../commonservices/CommonMethods";
import '../../Lender-Portal/MyDealers/RiskDashboard/RiskDashboard.css';
import LenderBanner from "./LenderBanner/LenderBanner";
import { lenderBanner } from "../../../store/Actions/Lender/CommonAction/CommonAction";
import { useLocation } from "react-router-dom";

const ViewNotes = (props) => {

    const dispatch = useDispatch();
    const storeData = useSelector((store) => store.sharedNotesReducer);
    const { lenderBanners } = useSelector(state => state.sharedReducer);
    const location = useLocation()
    const [activeTab, setTabstatus] = useState('');
    const [innerActiveTab, setInnerActiveTab] = useState('Lender Note');
    const [selectedRecordData, setSelectedRecordData] = useState({});
    const [showModalCN, setShowModalCN] = useState(false);
    const partnerDetails = localStorage.getItem('partnerDetails') ? JSON.parse(localStorage.getItem('partnerDetails')) : {};
    const [deleteNoteConfirmationState, setDeleteNoteConfirmationState] = useState({
        noteId: '',
        showModal: false
    });
    const [toaster, setToaster] = useState({
        header: '',
        class: '',
        content: '',
        showToaster: false
    });
    const [editNotes, setEditNotes] = useState(false);

    const tabChangeHandler = (key) => {
        setTabstatus(key)

        if (storeData.sharedNotesData && !storeData.sharedNotesData.notes[key]) {
            const dealer_id = storeData.sharedNotesData.dealerID ? storeData.sharedNotesData.dealerID : (props.selectedDealerID ? props.selectedDealerID : props.selectedDealer._id);
            dispatch(getSharedNotes(dealer_id, key, props.vehicleId));

        }

    }
    const cancelCN = () => {
        setShowModalCN(false);

    }

    useEffect(() => {
        // if (storeData.sharedNotesData && !storeData.sharedNotesData.notes[activeTab] && props.selectedDealerID !== storeData.sharedNotesData.dealerID)
        if (props.selectedDealer?.sopraDealerReference ?? props.selectedDealer?.dealerReference) {
           
            dispatch(lenderBanner(props.selectedDealer?.dealerId, props.selectedDealer?.sopraDealerReference ?? props.selectedDealer?.dealerReference ?? ''))
        }else if (props.selectedDealer?.sopraSupplierReference ?? props.selectedDealer?.supplierReference) {
            
            dispatch(lenderBanner(props.selectedDealer?.dealerId, props.selectedDealer?.sopraSupplierReference ?? props.selectedDealer?.supplierReference ?? ''), true)
        }
    }, [])
    

    useEffect(() => {
        if (lenderBanners.length > 0) {
            setTabstatus('Lender Banner')
        } else {
            setTabstatus(props.activeTab ? props.activeTab : 'Dealer Note')
            dispatch(getSharedNotes(props.selectedDealerID, props.activeTab ? props.activeTab : 'Dealer Note', props.vehicleId, props.auditDetails));
        }
    }, [lenderBanners,location.state?.dealerDetails])

    const toasterClose = () => {

        setToaster({
            header: '',
            class: '',
            content: '',
            showToaster: false
        })

    };
    const deleteNote = (event, noteId) => {

        event.preventDefault();
        event.stopPropagation();
       const req = {
            noteId:noteId ,
            noteType: activeTab
        }
        let Api = props.isTitleInventory ? '/tms/api/v1/inventory/deleteNotes':  '/lender/api/v1/lender/deleteNotesByType'
        return callAPI.delWithParams(Api,req)
            .then((response) => {

                if (response.status === 200) {
                     dispatch(getSharedNotes(storeData.sharedNotesData && storeData.sharedNotesData.dealerID, activeTab, props.vehicleId,null,props.isTitleInventory))
                        .then(response1 => {
                            if (props.setNotesTextUpdate)
                                props.setNotesTextUpdate(response1.notesData?.data[0]?.notes);
                        });
                    dispatch(setApiRefresh(true));
                    setDeleteNoteConfirmationState({
                        ...deleteNoteConfirmationState,
                        showModal: false
                    })
                    setToaster({
                        header: 'Success',
                        class: 'success-toaster',
                        content: 'Note Deleted successfully.',
                        showToaster: true
                    });

                }
                else {
                    setToaster({
                        header: 'Error',
                        class: 'error-toaster',
                        content: response.message,
                        showToaster: true
                    });

                }

            })
    }

    const editNote = (event, item, editNote) => {
        event.preventDefault();
        event.stopPropagation();
        setEditNotes(editNote);
        setSelectedRecordData(item)
        setShowModalCN(true);
    }

    const deleteNoteFunction = (noteId) => {
        setDeleteNoteConfirmationState({
            ...deleteNoteConfirmationState,
            noteId: noteId,
            showModal: true
        })
    }

    const closePopUp = () => {
        dispatch(setCreateNotesData({ showAddNote: false }));
        props.hideNotesViewModal();
        dispatch(setSharedNotes());
        // dispatch(setLenderBanner([]));
    }
    return (
        <>
            {props.showTableNotes ?
                <div className="shared-notes-table">
                    {
                        toaster.showToaster ?
                            <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                            : null
                    }

                    {storeData && storeData.sharedNotesLoader ? <Loader show={storeData?.sharedNotesLoader} styleType='fixed' /> : null}
                    <Tabs unmountOnExit={true} defaultActiveKey={props.activeTab}
                        activeKey={activeTab}
                        onSelect={(key) => tabChangeHandler(key)}
                        id="uncontrolled-tab-example">
                        {!props.hideDealerNote ?
                            <Tab eventKey="Dealer Note"
                                title={<>
                                    <span className="tabName"> Dealer Note</span>
                                    <span className="tabDataCount">
                                        {storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.dealerNotesCount}
                                    </span>
                                </>
                                }>
                                <SharedNotesTable
                                    deleteNoteHandler={deleteNoteFunction}
                                    editNoteHandler={editNote}
                                    onlyViewAccess={props.onlyViewAccess}
                                    activeTabName={activeTab}
                                    tableData={
                                        storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Dealer Note'] ?
                                            {
                                                sharedTableHeaders: storeData.sharedNotesData.notes['Dealer Note'].header,
                                                sharedTableData: storeData.sharedNotesData.notes['Dealer Note'].data,
                                            }
                                            : []}
                                />
                            </Tab> : null}
                        <Tab eventKey="Vehicle Note"
                            title={<>
                                <span><Image src={BorderEditIcon} className='fullVehicleDetailsPage-mobile-icon d-none' /><span className="tabName fullVehicleDetailsPageTabName"> Asset Note </span></span>
                                <span className="tabDataCount">
                                    {storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.vehicleNotesCount}
                                </span>
                            </>}>
                            <SharedNotesTable

                                deleteNoteHandler={deleteNoteFunction}
                                editNoteHandler={editNote}
                                activeTabName={activeTab}
                                onlyViewAccess={props.onlyViewAccess}
                                tableData={
                                    storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Vehicle Note'] ?
                                        {
                                            sharedTableHeaders: storeData.sharedNotesData.notes['Vehicle Note'].header,
                                            sharedTableData: storeData.sharedNotesData.notes['Vehicle Note'].data,
                                        }
                                        : []}
                            />
                        </Tab>
                        {partnerDetails && partnerDetails.titlesAllowed ?
                            <Tab eventKey="Title Note"
                                title={<>
                                    <span><Image src={BorderEditIcon} className='fullVehicleDetailsPage-mobile-icon d-none' /><span className="tabName fullVehicleDetailsPageTabName"> Title Note</span></span>
                                    <span className="tabDataCount">
                                        {storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.titleNotesCount}
                                    </span>
                                </>}>
                                <SharedNotesTable
                                    deleteNoteHandler={deleteNoteFunction}
                                    editNoteHandler={editNote}
                                    activeTabName={activeTab}
                                    onlyViewAccess={props.onlyViewAccess}
                                    tableData={
                                        storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Title Note'] ?
                                            {
                                                sharedTableHeaders: storeData.sharedNotesData.notes['Title Note'].header,
                                                sharedTableData: storeData.sharedNotesData.notes['Title Note'].data,
                                            }
                                            : []}
                                />
                            </Tab> : null}
                        <Tab eventKey="Audit Note" title={<><span><Image src={BorderEditIcon} className='fullVehicleDetailsPage-mobile-icon d-none' /><span className="tabName fullVehicleDetailsPageTabName"> Audit Note</span></span>
                            <span className="tabDataCount">
                                {
                                    storeData.sharedNotesData?.notes['Audit Note']?.data.length + storeData.sharedNotesData?.notes['Audit Note']?.inPersonData.length + storeData.sharedNotesData?.notes['Audit Note']?.virtualData.length ? storeData.sharedNotesData?.notes['Audit Note']?.data.length + storeData.sharedNotesData?.notes['Audit Note']?.inPersonData.length + storeData.sharedNotesData?.notes['Audit Note']?.virtualData.length : storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.auditNotesCount


                                }
                            </span>
                        </>}>
                            <Tabs unmountOnExit={true} defaultActiveKey={innerActiveTab}
                                activeKey={innerActiveTab}
                                onSelect={(key) => setInnerActiveTab(key)}
                                id="uncontrolled-innertab-example">
                                <Tab eventKey="Lender Note" title={<><span><Image src={BorderEditIcon} className='fullVehicleDetailsPage-mobile-icon d-none' /><span className="tabName fullVehicleDetailsPageTabName"> Lender Note</span></span>
                                    <span className="tabDataCount">
                                        {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].data && storeData.sharedNotesData.notes['Audit Note'].data.length}
                                    </span>
                                </>}>
                                    <SharedNotesTable
                                        deleteNoteHandler={deleteNoteFunction}
                                        editNoteHandler={editNote}
                                        innerTab={innerActiveTab}
                                        onlyViewAccess={props.onlyViewAccess}
                                        activeTabName={activeTab}
                                        tableData={
                                            storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].data && storeData.sharedNotesData.notes['Audit Note'].data.length > 0 ?
                                                {
                                                    sharedTableHeaders: storeData.sharedNotesData.notes['Audit Note'].header,
                                                    sharedTableData: storeData.sharedNotesData.notes['Audit Note'].data,
                                                }
                                                : []}
                                    />
                                </Tab>
                                {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].inPersonData && storeData.sharedNotesData.notes['Audit Note'].inPersonData.length > 0 ?
                                    <Tab eventKey="In Person Note" title={
                                        <>
                                            <span><Image src={BorderEditIcon} className='fullVehicleDetailsPage-mobile-icon d-none' />
                                                <span className="tabName fullVehicleDetailsPageTabName">
                                                    Auditor Notes
                                                    <Image src={auditsInpersonIcon} className="inperson-audits-grey ml-1" />
                                                    <Image src={auditsInpersonActiveIcon} className="inperson-audits-active ml-1" />
                                                </span></span>
                                            <span className="tabDataCount">
                                                {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].inPersonData && storeData.sharedNotesData.notes['Audit Note'].inPersonData.length}
                                            </span>
                                        </>}>
                                        <SharedNotesTable
                                            deleteNoteHandler={deleteNoteFunction}
                                            editNoteHandler={editNote}
                                            onlyViewAccess={props.onlyViewAccess}
                                            showAuditNotes={true}
                                            innerTab={innerActiveTab}
                                            activeTabName={activeTab}
                                            tableData={
                                                storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].inPersonData && storeData.sharedNotesData.notes['Audit Note'].inPersonData.length > 0 ?
                                                    {
                                                        sharedTableHeaders: storeData.sharedNotesData.notes['Audit Note'].inPersonHeaders,
                                                        sharedTableData: storeData.sharedNotesData.notes['Audit Note'].inPersonData,
                                                    }
                                                    : []}
                                        />
                                    </Tab>
                                    : ''}
                                {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].virtualData && storeData.sharedNotesData.notes['Audit Note'].virtualData.length > 0 ?
                                    <Tab eventKey="Virtual Note" title={
                                        <><span>
                                            <Image src={BorderEditIcon} className='fullVehicleDetailsPage-mobile-icon d-none' />
                                            <span className="tabName fullVehicleDetailsPageTabName">
                                                Auditor Notes
                                                <Image className="virtual-audits-grey ml-1" src={auditsVirtualIcon} />
                                                <Image className="virtual-audits-active ml-1" src={auditsVirtualActiveIcon} />
                                            </span></span>
                                            <span className="tabDataCount">
                                                {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].virtualData && storeData.sharedNotesData.notes['Audit Note'].virtualData.length}
                                            </span>
                                        </>}>
                                        <SharedNotesTable
                                            deleteNoteHandler={deleteNoteFunction}
                                            editNoteHandler={editNote}
                                            onlyViewAccess={props.onlyViewAccess}
                                            showAuditNotes={true}
                                            innerTab={innerActiveTab}
                                            activeTabName={activeTab}
                                            tableData={
                                                storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].virtualData && storeData.sharedNotesData.notes['Audit Note'].virtualData.length > 0 ?
                                                    {
                                                        sharedTableHeaders: storeData.sharedNotesData.notes['Audit Note'].virtualHeaders,
                                                        sharedTableData: storeData.sharedNotesData.notes['Audit Note'].virtualData,
                                                    }
                                                    : []}
                                        />
                                    </Tab> : null}
                            </Tabs>
                        </Tab>
                        <Tab eventKey="Payment Note" title={<><span><Image src={BorderEditIcon} className='fullVehicleDetailsPage-mobile-icon d-none' /><span className="tabName fullVehicleDetailsPageTabName"> Payment Note</span></span>
                            <span className="tabDataCount">
                                {storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.paymentNotesCount}
                            </span>
                        </>}>
                            <SharedNotesTable
                                deleteNoteHandler={deleteNoteFunction}
                                editNoteHandler={editNote}
                                activeTabName={activeTab}
                                onlyViewAccess={props.onlyViewAccess}
                                tableData={
                                    storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Payment Note'] ?
                                        {
                                            sharedTableHeaders: storeData.sharedNotesData.notes['Payment Note'].header,
                                            sharedTableData: storeData.sharedNotesData.notes['Payment Note'].data,
                                        }
                                        : []}
                            />
                        </Tab>
                        <Tab eventKey="History" title={<><span><Image src={BorderEditIcon} className='fullVehicleDetailsPage-mobile-icon d-none' /><span className="tabName fullVehicleDetailsPageTabName"> History</span></span>
                            <span className="tabDataCount">
                                {storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.historyNotesCount}
                            </span>
                        </>}>
                            <SharedNotesTable
                                deleteNoteHandler={deleteNoteFunction}
                                editNoteHandler={editNote}
                                activeTabName={activeTab}
                                tableData={
                                    storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['History'] ?
                                        {
                                            sharedTableHeaders: storeData.sharedNotesData.notes['History'].header,
                                            sharedTableData: storeData.sharedNotesData.notes['History'].data,
                                        }
                                        : []}
                            />
                        </Tab>
                    </Tabs>
                </div>
                :
                props.showOnlyDealerNote ?

                    <div className="shared-notes-table">
                        {
                            toaster.showToaster ?
                                <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                                : null
                        }
                        {storeData.sharedNotesLoader ? <Loader show={storeData.sharedNotesLoader} styleType='fixed' /> : null}
                        <SharedNotesTable
                            deleteNoteHandler={deleteNoteFunction}
                            editNoteHandler={editNote}
                            activeTabName={activeTab}
                            onlyViewAccess={props.onlyViewAccess}
                            tableData={
                                storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Dealer Note'] ?
                                    {
                                        sharedTableHeaders: storeData.sharedNotesData.notes['Dealer Note'].header,
                                        sharedTableData: storeData.sharedNotesData.notes['Dealer Note'].data,
                                    }
                                    : []}
                        />
                    </div>:
                    props.isTitleInventory ?
                    <div className="shared-notes-table">
                    {
                        toaster.showToaster ?
                            <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                            : null
                    }
                    {storeData.sharedNotesLoader ? <Loader show={storeData.sharedNotesLoader} styleType='fixed' /> : null}
                    <SharedNotesTable
                    deleteNoteHandler={deleteNoteFunction}
                    editNoteHandler={editNote}
                    activeTabName={activeTab}
                    onlyViewAccess={props.onlyViewAccess}
                    tableData={
                        storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Vehicle Note'] ?
                            {
                                sharedTableHeaders: storeData.sharedNotesData.notes['Vehicle Note'].header,
                                sharedTableData: storeData.sharedNotesData.notes['Vehicle Note'].data,
                            }
                            : []}
                />
                </div>
                    :
                    props.showOnlySupplierNote ?

                        <div className="shared-notes-table">
                            {
                                toaster.showToaster ?
                                    <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                                    : null
                            }
                            {storeData.sharedNotesLoader ? <Loader show={storeData.sharedNotesLoader} styleType='fixed' /> : null}
                            <SharedNotesTable
                                deleteNoteHandler={deleteNoteFunction}
                                editNoteHandler={editNote}
                                onlyViewAccess={props.onlyViewAccess}
                                activeTabName={activeTab}
                                tableData={
                                    storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Supplier Note'] ?
                                        {
                                            sharedTableHeaders: storeData.sharedNotesData.notes['Supplier Note'].header,
                                            sharedTableData: storeData.sharedNotesData.notes['Supplier Note'].data,
                                        }
                                        : []}
                            />
                        </div>
                        :
                        <Modal className={`modal-backdrop-bg-color default-large-popup shared-notes-table tableInPopup default-popup`} show={props.showModal}
                            onHide={() => closePopUp()} backdrop={props.isStatic ? "static" : null} centered={props.centered}>
                            <Modal.Header className='darkblue-bg-color' closeButton={props.isStatic ? false : true}>
                                <Modal.Title>

                                    <span className='popup-title-icon'><Image src={viewDealerNotesIcon} fluid /></span>
                                    <span className='flex-grow-1'>{props.modalTitle ? props.modalTitle : 'Notes'}</span>
                                    <span className='popup-close-icon'><X size={20} /></span>
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {
                                    toaster.showToaster ?
                                        <Toaster myClassName={toaster.class} onClose={toasterClose} header={toaster.header} content={toaster.content}></Toaster>
                                        : null
                                }
                                {storeData && storeData.sharedNotesLoader ? <Loader show={storeData?.sharedNotesLoader} styleType='fixed' /> : null}
                                <div className="tabs-with-table">
                                    {!props.isSupplier ? <Tabs unmountOnExit={true} defaultActiveKey={props.activeTab}
                                        activeKey={activeTab}
                                        onSelect={(key) => tabChangeHandler(key)}
                                        id="uncontrolled-tab-example">
                                        {lenderBanners.length > 0 ? <Tab eventKey="Lender Banner" title={<><span className="tabName"> Lender Banner</span>
                                            <span className="tabDataCount">
                                                {lenderBanners.length}
                                            </span> </>}>
                                            <LenderBanner
                                                LenderData={lenderBanners}
                                                selectedDealer={props.selectedDealer}
                                                setToaster={(data) => setToaster(data)}
                                            />
                                        </Tab> : ''}
                                        {!props.hideDealerNote ?
                                            <Tab eventKey="Dealer Note" title={<><span className="tabName"> Dealer Note</span>
                                                <span className="tabDataCount">
                                                    {storeData?.sharedNotesData?.counts && storeData?.sharedNotesData?.counts?.dealerNotesCount}
                                                </span> </>}>
                                                <SharedNotesTable
                                                    deleteNoteHandler={deleteNoteFunction}
                                                    editNoteHandler={editNote}
                                                    activeTabName={activeTab}
                                                    onlyViewAccess={props.onlyViewAccess}
                                                    tableData={
                                                        storeData?.sharedNotesData && storeData?.sharedNotesData?.notes && storeData.sharedNotesData.notes['Dealer Note'] ?
                                                            {
                                                                sharedTableHeaders: storeData.sharedNotesData.notes['Dealer Note'].header,
                                                                sharedTableData: storeData.sharedNotesData.notes['Dealer Note'].data,
                                                            }
                                                            : []}
                                                />
                                            </Tab> : null}
                                        <Tab eventKey="Vehicle Note" title={<><span className="tabName"> Asset Note</span>
                                            <span className="tabDataCount">
                                                {storeData?.sharedNotesData?.counts && storeData?.sharedNotesData?.counts?.vehicleNotesCount}
                                            </span>
                                        </>}>
                                            <SharedNotesTable
                                                deleteNoteHandler={deleteNoteFunction}
                                                editNoteHandler={editNote}
                                                activeTabName={activeTab}
                                                onlyViewAccess={props.onlyViewAccess}
                                                tableData={
                                                    storeData?.sharedNotesData && storeData?.sharedNotesData?.notes && storeData.sharedNotesData.notes['Vehicle Note'] ?
                                                        {
                                                            sharedTableHeaders: storeData.sharedNotesData.notes['Vehicle Note'].header,
                                                            sharedTableData: storeData.sharedNotesData.notes['Vehicle Note'].data,
                                                        }
                                                        : []}
                                            />
                                        </Tab>
                                        {partnerDetails && partnerDetails.titlesAllowed ?
                                            <Tab eventKey="Title Note" title={<><span className="tabName"> Title Note</span>
                                                <span className="tabDataCount">
                                                    {storeData?.sharedNotesData?.counts && storeData?.sharedNotesData?.counts?.titleNotesCount}
                                                </span>
                                            </>}>
                                                <SharedNotesTable
                                                    deleteNoteHandler={deleteNoteFunction}
                                                    editNoteHandler={editNote}
                                                    activeTabName={activeTab}
                                                    onlyViewAccess={props.onlyViewAccess}
                                                    tableData={
                                                        storeData?.sharedNotesData && storeData?.sharedNotesData?.notes && storeData.sharedNotesData.notes['Title Note'] ?
                                                            {
                                                                sharedTableHeaders: storeData.sharedNotesData.notes['Title Note'].header,
                                                                sharedTableData: storeData.sharedNotesData.notes['Title Note'].data,
                                                            }
                                                            : []}
                                                />
                                            </Tab> : null}
                                        <Tab eventKey="Audit Note" title={<><span className="tabName"> Audit Note</span>
                                            <span className="tabDataCount">
                                                {

                                                    storeData?.sharedNotesData?.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note']?.data.length + storeData.sharedNotesData.notes['Audit Note']?.inPersonData.length + storeData.sharedNotesData.notes['Audit Note'].virtualData.length ?
                                                        storeData.sharedNotesData?.notes['Audit Note']?.data.length + storeData.sharedNotesData?.notes['Audit Note']?.inPersonData.length + storeData.sharedNotesData?.notes['Audit Note']?.virtualData.length :
                                                        storeData?.sharedNotesData?.counts && storeData?.sharedNotesData?.counts?.auditNotesCount


                                                }
                                            </span>
                                        </>}>
                                            <Tabs unmountOnExit={true} defaultActiveKey={innerActiveTab}
                                                activeKey={innerActiveTab}
                                                onSelect={(key) => setInnerActiveTab(key)}
                                                id="uncontrolled-innertab-example">
                                                <Tab eventKey="Lender Note" title={<><span className="tabName"> Lender Note</span>
                                                    <span className="tabDataCount">
                                                        {storeData?.sharedNotesData?.notes['Audit Note']?.data.length}
                                                    </span>
                                                </>}>
                                                    <SharedNotesTable
                                                        deleteNoteHandler={deleteNoteFunction}
                                                        editNoteHandler={editNote}
                                                        innerTab={innerActiveTab}
                                                        onlyViewAccess={props.onlyViewAccess}
                                                        activeTabName={activeTab}
                                                        tableData={
                                                            storeData?.sharedNotesData?.notes['Audit Note']?.data && storeData.sharedNotesData.notes['Audit Note'].data.length > 0 ?
                                                                {
                                                                    sharedTableHeaders: storeData?.sharedNotesData?.notes['Audit Note']?.header,
                                                                    sharedTableData: storeData?.sharedNotesData?.notes['Audit Note']?.data,
                                                                }
                                                                : []}
                                                    />
                                                </Tab>
                                                {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].inPersonData && storeData.sharedNotesData.notes['Audit Note'].inPersonData.length > 0 ?
                                                    <Tab eventKey="In Person Note" title={<>
                                                        <span className="tabName">
                                                            Auditor Notes
                                                            <Image src={auditsInpersonIcon} className="inperson-audits-grey ml-1" />
                                                            <Image src={auditsInpersonActiveIcon} className="inperson-audits-active ml-1" />
                                                        </span>
                                                        <span className="tabDataCount">
                                                            {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].inPersonData && storeData.sharedNotesData.notes['Audit Note'].inPersonData.length}
                                                        </span>
                                                    </>}>
                                                        <div className="inperson-auditor-notes">
                                                            <SharedNotesTable
                                                                deleteNoteHandler={deleteNoteFunction}
                                                                editNoteHandler={editNote}
                                                                showAuditNotes={true}
                                                                innerTab={innerActiveTab}
                                                                activeTabName={activeTab}
                                                                tableData={
                                                                    storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].inPersonData && storeData.sharedNotesData.notes['Audit Note'].inPersonData.length > 0 ?
                                                                        {
                                                                            sharedTableHeaders: storeData.sharedNotesData.notes['Audit Note'].inPersonHeaders,
                                                                            sharedTableData: storeData.sharedNotesData.notes['Audit Note'].inPersonData,
                                                                        }
                                                                        : []}
                                                            />
                                                        </div>
                                                    </Tab>
                                                    : ''}
                                                {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].virtualData && storeData.sharedNotesData.notes['Audit Note'].virtualData.length > 0 ?
                                                    <Tab eventKey="Virtual Note" title={
                                                        <>
                                                            <span className="tabName">
                                                                Auditor Notes
                                                                <Image className="virtual-audits-grey ml-1" src={auditsVirtualIcon} />
                                                                <Image className="virtual-audits-active ml-1" src={auditsVirtualActiveIcon} />
                                                            </span>
                                                            <span className="tabDataCount">
                                                                {storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].virtualData && storeData.sharedNotesData.notes['Audit Note'].virtualData.length}
                                                            </span>
                                                        </>}>
                                                        <div className="virtual-auditor-notes">
                                                            <SharedNotesTable
                                                                deleteNoteHandler={deleteNoteFunction}
                                                                editNoteHandler={editNote}
                                                                showAuditNotes={true}
                                                                innerTab={innerActiveTab}
                                                                onlyViewAccess={props.onlyViewAccess}
                                                                activeTabName={activeTab}
                                                                tableData={
                                                                    storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Audit Note'] && storeData.sharedNotesData.notes['Audit Note'].virtualData && storeData.sharedNotesData.notes['Audit Note'].virtualData.length > 0 ?
                                                                        {
                                                                            sharedTableHeaders: storeData.sharedNotesData.notes['Audit Note'].virtualHeaders,
                                                                            sharedTableData: storeData.sharedNotesData.notes['Audit Note'].virtualData,
                                                                        }
                                                                        : []}
                                                            />
                                                        </div>
                                                    </Tab> : null}
                                            </Tabs>
                                        </Tab>
                                        <Tab eventKey="Payment Note" title={<><span className="tabName"> Payment Note</span>
                                            <span className="tabDataCount">
                                                {storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.paymentNotesCount}
                                            </span>
                                        </>}>
                                            <SharedNotesTable
                                                deleteNoteHandler={deleteNoteFunction}
                                                editNoteHandler={editNote}
                                                activeTabName={activeTab}
                                                onlyViewAccess={props.onlyViewAccess}
                                                tableData={
                                                    storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Payment Note'] ?
                                                        {
                                                            sharedTableHeaders: storeData.sharedNotesData.notes['Payment Note'].header,
                                                            sharedTableData: storeData.sharedNotesData.notes['Payment Note'].data,
                                                        }
                                                        : []}
                                            />
                                        </Tab>
                                        <Tab eventKey="History" title={<><span className="tabName"> History</span>
                                            <span className="tabDataCount">
                                                {storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.historyNotesCount}
                                            </span>
                                        </>}>
                                            <SharedNotesTable
                                                deleteNoteHandler={deleteNoteFunction}
                                                editNoteHandler={editNote}
                                                activeTabName={activeTab}
                                                tableData={
                                                    storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['History'] ?
                                                        {
                                                            sharedTableHeaders: storeData.sharedNotesData.notes['History'].header,
                                                            sharedTableData: storeData.sharedNotesData.notes['History'].data,
                                                        }
                                                        : []}
                                            />
                                        </Tab>
                                    </Tabs> :
                                        <Tabs unmountOnExit={true} defaultActiveKey={props.activeTab}
                                            activeKey={activeTab}
                                            onSelect={(key) => tabChangeHandler(key)}
                                            id="uncontrolled-tab-example">
                                            {lenderBanners.length > 0 ? <Tab eventKey="Lender Banner" title={<><span className="tabName"> Lender Banner</span>
                                            <span className="tabDataCount">
                                                {lenderBanners.length}
                                            </span> </>}>
                                            <LenderBanner
                                                LenderData={lenderBanners}
                                                selectedDealer={props.selectedDealer}
                                                setToaster={(data) => setToaster(data)}
                                            />
                                        </Tab> : ''}
                                            <Tab eventKey="Supplier Note" title={<><span className="tabName">Supplier Note
                                                <span className="tabDataCount">
                                                    {storeData.sharedNotesData.counts && storeData.sharedNotesData.counts.supplierNotesCount}
                                                </span>
                                            </span></>}>
                                                <SharedNotesTable
                                                    deleteNoteHandler={deleteNoteFunction}
                                                    editNoteHandler={editNote}
                                                    activeTabName={activeTab}
                                                    onlyViewAccess={props.onlyViewAccess}
                                                    tableData={
                                                        storeData.sharedNotesData && storeData.sharedNotesData.notes && storeData.sharedNotesData.notes['Supplier Note'] ?
                                                            {
                                                                sharedTableHeaders: storeData.sharedNotesData.notes['Supplier Note'].header,
                                                                sharedTableData: storeData.sharedNotesData.notes['Supplier Note'].data,
                                                            }
                                                            : []}
                                                />
                                            </Tab>
                                        </Tabs>
                                    }
                                </div>
                            </Modal.Body>
                        </Modal>
            }

            <CreateNote
                showModalCN={showModalCN}
                cancelCN={cancelCN}
                noteType={!editNotes && storeData?.createNotesData?.noteType?.length > 0 ? storeData?.createNotesData?.noteType : activeTab}
                data={selectedRecordData}
                restrictVehicleId={props.restrictVehicleId}
                vehicleId={props.vehicleId}
                dealerIDForEdit={storeData.sharedNotesData && storeData.sharedNotesData.dealerID}
                action={editNotes ? 'editNote' : ''}
                getNotesCall={!editNotes ? true : false}
                isTitleInventory={props.isTitleInventory ? true : false}
            />
            <ConfirmationPopup
                title="Are you sure want to delete note?"
                onClose={() => setDeleteNoteConfirmationState({
                    ...deleteNoteConfirmationState,
                    showModal: false
                })}
                showModal={deleteNoteConfirmationState.showModal}
                primaryActionLabel="Yes"
                secondaryActionLabel="No"
                primaryAction={(event) => { deleteNote(event, deleteNoteConfirmationState.noteId) }}
                secondaryAction={() => {
                    setDeleteNoteConfirmationState({
                        ...deleteNoteConfirmationState,
                        showModal: false
                    })
                }}
            />
        </>
    )
}

export default ViewNotes;